var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckThickGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/16px/Check_thick") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.32197138,10.6283374 L12.266673,3.3515926 C12.5898415,2.96266816 13.1706834,2.8873037 13.5880709,3.17113817 C14.0416741,3.47890195 14.1392198,4.09663371 13.7876131,4.52074213 L7.1386671,12.647817 C6.95960579,12.863828 6.69260702,12.9908166 6.43229937,12.9981626 C6.39338065,13 6.39338065,13 6.37836207,13 C6.10968422,13 5.85068893,12.8933805 5.66582965,12.7012117 L2.26080921,9.1754946 C1.8776071,8.77966312 1.92348085,8.15531116 2.35363937,7.81429764 C2.74960387,7.49952896 3.33499139,7.53535426 3.68594965,7.89887792 L6.32197138,10.6283374 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/16px/Check_thick",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "check",
    fill: "#8A8E96",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckThickGray);
export default __webpack_public_path__ + "static/media/Check_thick_gray.1d38a9e479195a829d31b80e2b4b68f1.svg";
export { ForwardRef as ReactComponent };